import axios from 'axios';

const BACKEND_URL = 'https://rsvp.danieltracer.com/api';

const instance = axios.create({
  baseURL: BACKEND_URL,
});

async function handleBackendResponse(makeRequest, showSnackbar) {
  try {
    const { data, status } = await makeRequest();
    return data;
  } catch (error) {
    console.error('Network error:', error);
    const errorMessage =
      error.response.data.error || `Network error ${error.response.status}`;
    if (typeof showSnackbar === 'function') {
      showSnackbar(errorMessage, 'error');
    }
    throw new Error(errorMessage);
  }
}

async function backendPost(path, data, showSnackbar) {
  const response = await handleBackendResponse(
    async () => await instance.post(`${BACKEND_URL}${path}`, data),
    showSnackbar,
  );
  return response;
}

export async function fetchUserDetails(token, showSnackbar) {
  try {
    return await backendPost('/user', { token }, showSnackbar);
  } catch (error) {
    console.error('Error fetching user details:', error);
    throw error;
  }
}

export async function fetchRsvpDetails(token, showSnackbar) {
  try {
    return await backendPost('/rsvp_details', { token }, showSnackbar);
  } catch (error) {
    console.error('Error fetching rsvp details:', error);
    throw error;
  }
}

export async function submitRsvpResponses(token, response, showSnackbar) {
  try {
    return await backendPost('/submit_rsvp', { token, response }, showSnackbar);
  } catch (error) {
    console.error('Error submitting rsvp responses:', error);
    throw error;
  }
}
